/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type RestoreOktaServerSuggestionRequestBody = {
  /**
   * Catalog entry of the suggestion to restore.
   */
  registryEntryId: string;
};

/** @internal */
export type RestoreOktaServerSuggestionRequestBody$Outbound = {
  registry_entry_id: string;
};

/** @internal */
export const RestoreOktaServerSuggestionRequestBody$outboundSchema:
  z.ZodMiniType<
    RestoreOktaServerSuggestionRequestBody$Outbound,
    RestoreOktaServerSuggestionRequestBody
  > = z.pipe(
    z.object({
      registryEntryId: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        registryEntryId: "registry_entry_id",
      });
    }),
  );

export function restoreOktaServerSuggestionRequestBodyToJSON(
  restoreOktaServerSuggestionRequestBody:
    RestoreOktaServerSuggestionRequestBody,
): string {
  return JSON.stringify(
    RestoreOktaServerSuggestionRequestBody$outboundSchema.parse(
      restoreOktaServerSuggestionRequestBody,
    ),
  );
}
